<template>
    <div class="dsd-input">
        <label class="form-label form-label--alternate form-label--inlineSmall" v-if="label !== ''">
            {{ label }}
            <small v-if="required">Required</small>
        </label>
        <div class="form-input-wrap" :class="{'d-flex': button !== ''}">
            <div class="pos-rel">
                <input type="text" class="form-input" :class="classes" :placeholder="placeholder" :value="value" v-on:input="updateValue($event.target.value)" :disabled="isLoading" :maxlength="maxlength" :minlength="minlength" @blur="$emit('blur', value)" isp_ignore/>
                <span class="form-input-spinner" v-if="isLoading">
                    <svg width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="2" stroke-linecap="round" cx="8" cy="8" r="7"></circle>
                    </svg>
                </span>
            </div>
            <button v-if="button !== ''" class="dsd-input-btn" @click="$emit('btnclick', $event)">{{button}}</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false,
        },
        uppercase: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        button: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'small',
            validator: (prop) => ['small', 'medium', 'large'].includes(prop),
        },
        maxlength: {
            type: Number,
            default: 500,
        },
        minlength: {
            type: Number,
            default: 0,
        },
    },
    data: () => ({
        isLoading: false,
    }),
    computed: {
        style() {
            return this.dimensions !== void 0 ? { width: this.dimensions, height: this.dimensions } : { width: this.width, height: this.height, borderRadius: this.radius };
        },

        classes() {
            return `form-input--${this.size}` + (this.uppercase === true ? ' form-input--uppercase' : '');
        },
    },
    methods: {
        updateValue: function(value) {
            if (this.uppercase) {
                value = value.toUpperCase();
            }
            this.$emit('input', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.dsd-input {
    position: relative;
}
.form-input-wrap {
    position: relative;
}
.form-input--uppercase {
    text-transform: uppercase !important;
}
/* SVG spinner */
@keyframes form-input-spinner {
    0% {
        transform: rotate(5deg);
    }
    50% {
        transform: rotate(185deg);
    }
    100% {
        transform: rotate(365deg);
    }
}
.form-input-spinner {
    margin: 0 2px 0 0;
    vertical-align: -2px;
    position: absolute;
    right: 6px;
    top: 6px;
}
.form-input-spinner svg {
    animation: form-input-spinner 0.8s linear infinite;
}
.form-input-spinner .path {
    stroke-dasharray: 60;
    stroke-dashoffset: 30;
    transform-origin: center;
    stroke: #333;
}
.pos-rel {
    position: relative;
}
.d-flex {
    display: flex;
    justify-content: space-between;
}
.d-flex .pos-rel {
    flex: 0 78%;
}
.d-flex button {
    flex: 0 18%;
    border-radius: 4px;
    background: #ef060a;
    color: #fff;
}
.d-flex button:hover {
    background: #be0508;
    color: #fff;
}
</style>
